<template>
  <div>
    <a-card>
      <div v-if="task.uploadLoading" style="text-align: center;">
        上传中 已完成{{upload.progress + '%'}}<a-spin style="margin-left:5px;" />
      </div>
      <a-form layout="inline" ref="searchForm" :model="form.searchForm" style="margin-bottom: 20px;">
        <a-form-item label="任务类型" name="takType">
          <a-select
            style="width: 140px"
            v-model:value="form.searchForm.takType"
            :options="optData.taskTypeOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="子任务状态" name="status">
          <a-select
            style="width: 140px"
            v-model:value="form.searchForm.status"
            :options="optData.taskStatusOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="关键字" name="keywords">
          <a-input style="width: 200px" ref="keywords" placeholder="根据子任务编号/名称查询" v-model:value="form.searchForm.keywords" autocomplete="off">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
        </a-form-item>
      </a-form>
      <a-table :dataSource="task.list" :columns="columns" :pagination="false">
        <template v-slot:taskType="{ record }">
          {{ statusTrans(record.type, taskType) }}
        </template>
        <template v-slot:taskStatus="{ record }">
          <div> 
            {{ statusTrans(record.state, subtaskSatus) }}
          </div>
        </template>
        <template v-slot:action="{ record }">
          <div> 
            <div v-if="record.labelType == 'online'">
              <div v-if="record.state == 'to_be_labeled'">  <!-- 待标注 -->
           
                <span v-if="record.type == 'tag'" class="gap-btn">
                  <a-popconfirm
                  title="请确认在筛选前已阅读筛选说明,若未阅读标注说明，请于查看界面下载。"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="taskLabel(record)"
                >
                  <a href="#">筛选</a>
                </a-popconfirm>
                </span>   

                <span v-else class="gap-btn">
                  <a-popconfirm
                  title="请确认在标注前已阅读标注说明,若未阅读标注说明，请于查看界面下载。"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="taskLabel(record)"
                >
                  <a href="#">标注</a>
                </a-popconfirm>
                </span>
                <span class="gap-btn">
                  <a @click="openSubDetail(record)">查看</a>
                </span>
              </div>
              
              <div v-else-if="record.state == 'in_labeling'">  <!-- 标注中 -->
                <span class="gap-btn">
                  <a-popconfirm v-if="record.type == 'tag'"
                    title="确认已经完成数据筛选?"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="labelFinished(record)"
                  >
                    <a>筛选完成</a>
                  </a-popconfirm>
                  <a-popconfirm v-else
                    title="确认已经完成数据标注?"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="labelFinished(record)"
                  >
                    <a>标注完成</a>
                  </a-popconfirm>
                </span>
                <span class="gap-btn" v-if="record.type == 'tag'">
                  <a @click="opensievingDetail(record)">筛选</a>
                </span>
                <span class="gap-btn">
                  <a @click="openSubDetail(record)">查看</a>
                </span>
              </div>
  
              <div v-else-if="record.state == 'inspection_failed'">   <!-- 质检不通过 -->
                <span class="gap-btn">
                  <a-popconfirm v-if="record.type == 'tag'"
                  title="确认已经完成数据筛选?"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="labelFinished(record)"
                >
                  <a>筛选完成</a>
                  
                </a-popconfirm>
                <a-popconfirm v-else
                  title="确认已经完成数据标注?"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="labelFinished(record)"
                >
                  <a>标注完成</a>
                  
                </a-popconfirm>
                </span>
                <span class="gap-btn" v-if="record.type == 'tag'">
                  <a @click="opensievingDetail(record)">筛选</a>
                </span>
                <span class="gap-btn">
                  <a @click="openSubDetail(record)">查看</a>
                </span>
              </div>
              
              <div v-else>
                <span class="gap-btn">
                  <a @click="openSubDetail(record)">查看</a>
                </span>
              </div>
            </div>
            <div v-if="record.labelType == 'offline'">
              <div v-if="record.state == 'to_be_labeled'">  <!-- 待标注 -->
                <span class="gap-btn">
                  <a @click="download(record)">下载</a>
                </span>
                <span @click="showTips(record)" class="gap-btn" style="display: inline-block;">
                 上传
                </span>
                <span class="gap-btn">
                  <a-popconfirm
                  title="确认已经完成数据标注，并完成线下质检？"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="labelFinished(record)"
                >
                  <a>标注完成</a>
                </a-popconfirm>
                </span>
                <span class="gap-btn">
                  <a @click="openSubDetail(record)">查看</a>
                </span>
              </div> 
              <div v-else>
                <span class="gap-btn">
                  <a @click="openSubDetail(record)">查看</a>
                </span>
              </div> 
            </div>
          </div>
        </template>
      </a-table>
      <div class="mt20">
        <a-pagination
        v-model:current="task.page.num"
        show-quick-jumper
        :pageSize=task.page.size
        :total="task.page.total"
        :show-total="total => `共 ${total} 条`"
        @change="getTaskList"
      ></a-pagination>
      </div>
    </a-card>
    <a-modal v-model:visible="upload.tipShow" title="上传提示" @ok="handleOk">
      <p>请将图片和标注打包为压缩包，并确保图片和标注文件名一致。</p>

      <p>本平台仅支持labelme格式标注。</p>
    </a-modal>

    <!-- -->
    <div style="opacity: 0;">  <!--  uploadRequest -->
      <a-upload ref="uploadCom"
        :customRequest="uploadRequest"
        v-model:file-list="upload.fileList"
        name="file"
        :multiple="false"
        :auto-upload="false"
        :openFileDialogOnClick="upload.showFileDialog"
        :showUploadList="false"
        accept=".zip"
        :data="{labelTaskSubId:upload.id}"
        >
        <a ref="uploadBtn" type="text">上传</a>  
        <!-- showTips -->
      </a-upload>
      <el-button @click="startUpload" :disabled="!uploadable">开始上传</el-button>
    </div>
    
  </div>
</template>


<script>
import axios from 'axios'
const columns = [
  {
    title: '任务编号',
    dataIndex: 'number'
  },
  {
    title: '任务名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'type',
    slots: { customRender: 'taskType' }

  },
  {
    title: '任务状态',
    dataIndex: 'state',
    slots: { customRender: 'taskStatus' }
   

  },
  {
    title: '发布人',
    dataIndex: 'createUserName',

  },

  {
    title: '发布时间',
    dataIndex: 'createTime',
   
  },
  {
    title: '要求完成时间',
    dataIndex: 'endTime',

  },
  {
    title: '操作',
    slots: { customRender: 'action' }

  }
]

import {ref, reactive, onMounted, getCurrentInstance, nextTick} from "vue";
import {createWebHistory, useRoute, useRouter} from 'vue-router'

import { mapState } from 'vuex'
import { message } from 'ant-design-vue';
import { useStore } from '@/store/index2'
import {statusToCn} from '@/filters'
import {publicConfig} from '@/publicConfig.js'

import { md5 } from 'js-md5';



console.log(md5('123456'))



import {subpageForServer, label, labelStart, labelCompleted, exportItems} from '@/api/taskRelease'


message.config({
  maxCount:1,
  duration:1,
})

export default{
  components:{
    
  },
  computed: {
    ...mapState(['appConfig'])
  },
  setup(){
    const router = useRouter()
    const route = useRoute()

    let instance = getCurrentInstance()

  
    let task = reactive({
      list:[],
      taskFormVisible:false,
      fromType:'creat',
      page:{
        num:1,
        size:10,
        total:0
      },
      taskData:[],
      uploadLoading:false
    })


    // 子任务详细  数据标注页面
    function openSubDetail(record){
      debugger
      localStorage.setItem('subTask',JSON.stringify([{id:record.id,number:record.number}]))
      router.push(`/labelDetail?form=sub&taskId=${record.taskId}&subTaskId=${record.id}&type=view`)  //&page=annotator
      return
    }


     // 筛选页面
     function opensievingDetail(record){
      localStorage.setItem('subTask',JSON.stringify([{id:record.id,number:record.number}]))
      router.push(`/sievingDetail?form=sub&page=sieving&taskId=${record.taskId}&subTaskId=${record.id}&type=view`)  //&page=annotator
      return
    }


    

    let store = useStore()


    let {taskSatus,subtaskSatus,taskType } = store

    function statusTrans(state, stateObj){
      return statusToCn(state, stateObj)
    }
  
    let form = reactive({
      searchForm:{
        takType:'',
        status:'',
        keywords:'',
      }
    })
    
    // 搜索表单  select下拉列表
    let optData = reactive({
      taskTypeOpt:[{label:'全部',value:''}],
      taskStatusOpt:[{label:'全部',value:''}],
    })


    function initData(){
      try {
        for(let prop in taskType){
          optData.taskTypeOpt.push({
            value:prop,
            label:taskType[prop]
          }) 
        }

        for(let prop in subtaskSatus){
          optData.taskStatusOpt.push({
            value:prop,
            label:subtaskSatus[prop]
          }) 
        }

      } catch (error) {
        
      }
    }

    //  搜索
    const search = ()=>{
      task.page.num = 1
      getTaskList()
    }

    //  任务列表  
    const getTaskList = async ()=>{
      task.list = []
      let params = {
        groupId:JSON.parse(localStorage.getItem('westCurrentRole')).teamId,
        keyword:form.searchForm.keywords,
        pageNum:task.page.num,
        pageSize:task.page.size,
        states: form.searchForm.status,
        type:form.searchForm.takType,
        opType:'label',
        //visibility:'',
      }
      const {data:res} = await subpageForServer(params)
        const list = [...res.data.records]
       
        task.list = list
        task.page.total = res.data.total

    }


    onMounted(() => {
      getTaskList()
      initData()
    })




    // 标注 
    async function taskLabel(record){
      let params = {
        labelTaskSubId:record.id,
      }
      const {data:res} = await labelStart(params)
      if(res.code == 0){
        message.success('请使用标注工具进行标注')
        if(record.type == 'tag'){
          opensievingDetail(record)
        }else{
          getTaskList()
        }
      
      }else{
        message.error(res.msg)
      }
    }

    


      // 标注完成
    async function labelFinished(record){
      let params = {
        labelTaskSubId:record.id,
      }
      const {data:res} = await labelCompleted(params)
      if(res.code == 0){
        message.success(res.msg)
        getTaskList()
      }else{
        message.error(res.msg)
      }
      
    }

    const token = localStorage.getItem('westToken')
    let upload = reactive({
      action:publicConfig.requestUrl + '/welldbCombine/api/labelData/upload/chunk/create',   //publicConfig.requestUrl
      headers:{
        Authorization:"bearer " + token,
        'Content-Type': 'multipart/form-data'
      },  //Cookies.get('access_token')
      fileList:[],
      tipShow:false,
      showFileDialog:false,
      chunkSize:1024 * 1024 * 5,  // 每个切片大小为50MB
      chunks:0,
      currentChunkIndex:0,
      progress:0,
    })


    const getFileMd5 = (file)=>{
      return new Promise((resolve, reject) => {
        const reader = new FileReader()  
        reader.readAsArrayBuffer(file)
        reader.onload = function(e) {
          resolve(md5(e.target.result))
        }
        reader.onerror = function(err){
          reject(err)
        }
      })
    }

   
    async function uploadChunks(file) {
      task.uploadLoading = true
      getFileMd5(file).then(async (fileMd5)=>{
        while (upload.currentChunkIndex < upload.chunks) {
          const start = upload.currentChunkIndex * upload.chunkSize;
          const end = Math.min(start + upload.chunkSize, file.size);
          const chunk = file.slice(start, end);
          
          const formData = new FormData();
          let chunkMd5 = await getFileMd5(chunk)

          formData.append('labelTaskSubId', upload.id)
          formData.append('chunkSize', upload.chunkSize)
          formData.append('chunks',  upload.chunks)
        // formData.append('currentChunkMd5',  md5(reader.readAsText(chunk)))
          formData.append('file', chunk, `${file.name}`)
          //formData.append('file', chunk, `${file.name}_chunk_${upload.currentChunkIndex}`)
          formData.append('fileMd5', fileMd5)
          formData.append('currentChunkMd5',  md5(chunkMd5))  

          //formData.append('currentChunkMd5',  md5('_chunk_' +  upload.currentChunkIndex))
          formData.append('size',  file.size)
          formData.append('currentChunk',  upload.currentChunkIndex)
          const config = {
            url: upload.action,
            method: 'POST',
            //timeout: 30000, // 设置超时时间为30秒
            headers: upload.headers, // 可以添加请求头信息
            data: formData
          };

          try{
            const {data} = await axios.request(config)
            if(data.code === 0) {
              upload.currentChunkIndex++;
              
              upload.progress = Math.floor((parseInt(upload.currentChunkIndex)/parseInt(upload.chunks)) * 100)
              

            }else{
              task.uploadLoading = false
              upload.fileList = []
              message.error('文件上传失败')
              break
            }
          }catch(err){
            message.error('上传异常')
            task.uploadLoading = false
            upload.fileList = []
            break
          }
          
          
        }

        if (upload.currentChunkIndex === upload.chunks) {
          task.uploadLoading = false
          message.success('上传成功')
        }

      }).catch(()=>{
        message.error('文件读取失败')
      }) 
    }


    async function uploadRequest({ file, onSuccess, onError }) {
      //this.fileList = [file]; // 更新fileList
      upload.chunks = Math.ceil(file.size / upload.chunkSize); // 计算切片数量
      upload.currentChunkIndex = 0;
      upload.progress = 0
      //this.uploadable = true; // 设置可以开始上传

      
     
      await uploadChunks(file);

      //return
       




      //labelTaskSubId:labelTaskSubId:upload.id)
      


    

      // task.uploadLoading = true
      // axios.request(config)
      //   .then(({data:res}) => {
      //     debugger
        
      //     if(res && res.code == 0){
      //       message.success('上传完成')
      //       upload.tipShow = false
      //       if(upload.fileList.length > 1){
      //         upload.fileList = upload.fileList.splice(1,1)
      //       }

      //       task.uploadLoading = false

      //     }else{
      //       message.error('上传失败')

      //       upload.fileList = []
      //       task.uploadLoading = false

      //     }
      //     onSuccess(res.data);
      //   })
      //   .catch((error) => {
      //     message.error('上传失败')
      //     upload.fileList = []
      //     task.uploadLoading = false
      //     onError(error);
      //   });
    }


    function uploadchange(info){
      return
      alert('uploadchange')
      console.log('uploadchange')
      console.log(info.fileList)
      task.uploadLoading = true
      const response = info.fileList[0].response
      debugger
      if(response && !response.data){
        message.error(info.fileList[1].response.message)
        upload.fileList = []
        return
      }
      if(response && response.code == 0 ){
        message.success('上传完成')
        upload.tipShow = false
        if(upload.fileList.length > 1){
          upload.fileList = upload.fileList.splice(1,1)
        }

        task.uploadLoading = false
      }

      if(response && response.code != 0){
        message.error('上传失败')
        task.uploadLoading = false
      }
    }

    function showTips(record){
      upload.tipShow = true
      upload.id = record.id
    }

    function handleOk(){    
      console.log('instance',instance)
      upload.showFileDialog = true
      nextTick(()=>{
        instance.refs.uploadBtn.click()
        upload.tipShow = false
        upload.showFileDialog = false
      })
    }

     /* 下载 交互 */
     let downloadData =  reactive({
      visible:false,
      loading:false,
      path:'',
      record:{}
    })

    function downloadHandle(record){
      downloadData.visible = true
      downloadData.record = {...record}
    }
    async function download(record){
      let params = {
        labelTaskSubId:record.id,
      }
      downloadData.loading = true
      const {data:res} = await exportItems(params)
      if(res.code == 0){
        message.success(res.msg)
        debugger
        const a = document.createElement('a')

        // 根据解析后的blob对象创建URL 对象
        const herf = instance.ctx.appConfig.baseImgUrl + res.data
        // 下载链接
        a.href = herf
        // 下载文件名,如果后端没有返回，可以自己写a.download = '文件.pdf'
        a.download = ''
        document.body.appendChild(a)
        // 点击a标签，进行下载 
        a.click()
        // 收尾工作，在内存中移除URL 对象
        document.body.removeChild(a)

        //window.open(instance.ctx.appConfig.baseImgUrl + res.path)
      }else{
        message.error(res.msg)
      }
      downloadData.loading = false
      downloadData.visible = false
    }


    return{   
      form,
      columns,
      taskType,
      taskSatus,
      subtaskSatus,
      statusToCn,
      getTaskList,
      task,
      statusTrans,
      optData,
      search,
      openSubDetail,
      opensievingDetail,
      taskLabel,
      labelFinished,
      downloadData,
      download,
      downloadHandle,
      upload,
      handleOk,
      showTips,
      uploadRequest,
      uploadchange,
      uploadChunks

    }
  }
}
</script>


<style>

</style>
